import React from 'react';

import pdf from '../files/pdf.png'

import {
    Button,
    Toolbar,
    Window,
    WindowHeader,
    WindowContent,
    Fieldset,
    Anchor
} from 'react95';

export const Contact = () => {
    return (
        <Window style={{ width: 550, maxWidth: "90vw" }}>
            <WindowHeader>
          contact.exe
        </WindowHeader>
            <Toolbar>
                <Button variant='menu' size='sm'>
                    File
        </Button>
                <Button variant='menu' size='sm'>
                    Edit
        </Button>
                <Button variant='menu' size='sm' disabled>
                    Save
        </Button>
            </Toolbar>
            <WindowContent>
                <div className="container-fluid " style={{ padding: "0" }}>
                    <div className="row no-gutters">
                        <div className="col-md-12 col-sm-12 col-12">
                            <Fieldset label="Let's have a chat!" >
                                <p style={{ overflowWrap: "break-word", marginBottom: "0" }}>
                                    If you want to hire me or invite to a project, just email me on <Anchor href='mailto:LukaszRams1997@gmail.com'>
                                        {' '}
                                                    LukaszRams1997@gmail.com
                                        </Anchor>
                                </p>
                            </Fieldset>
                        </div>
                    </div>
                </div>
            </WindowContent>
        </Window>
    );
}